import { cookieOptions } from "./cookieConfig.js";

const AUTH_COOKIE_KEYS = ["userRId", "tokenR", "userR", "tokenImpersonator"];
const JWT_PARTS = 3;
const EXP_LEEWAY_SECONDS = 30;

const normalizeToken = (token) => {
    if (!token || typeof token !== "string") return null;
    const trimmed = token.trim();
    if (!trimmed) return null;
    return trimmed.startsWith("Bearer ") ? trimmed.slice(7).trim() : trimmed;
};

const decodeBase64 = (value) => {
    if (!value) return null;

    try {
        if (typeof atob === "function") {
            return atob(value);
        }
    } catch (_e) {
        // Fallback to Buffer below.
    }

    try {
        if (typeof Buffer !== "undefined") {
            return Buffer.from(value, "base64").toString("utf8");
        }
    } catch (_e) {
        return null;
    }

    return null;
};

const decodeJwtPayload = (token) => {
    const normalizedToken = normalizeToken(token);
    if (!normalizedToken) return null;

    const parts = normalizedToken.split(".");
    if (parts.length !== JWT_PARTS) return null;

    const base64Url = parts[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), "=");
    const decoded = decodeBase64(padded);
    if (!decoded) return null;

    try {
        return JSON.parse(decoded);
    } catch (_e) {
        return null;
    }
};

export const isTokenExpired = (token, nowInSeconds = Math.floor(Date.now() / 1000)) => {
    const payload = decodeJwtPayload(token);
    if (!payload || typeof payload.exp !== "number") {
        return true;
    }

    return payload.exp <= nowInSeconds + EXP_LEEWAY_SECONDS;
};

export const hasValidToken = (token) => {
    const normalized = normalizeToken(token);
    if (!normalized) return false;
    return !isTokenExpired(normalized);
};

export const hasValidAuthSession = (cookies) => {
    if (!cookies || typeof cookies.get !== "function") return false;
    const user = cookies.get("userR");
    const token = cookies.get("tokenR");

    if (!user) return false;
    return hasValidToken(token);
};

export const clearAuthCookies = (cookies) => {
    if (!cookies || typeof cookies.remove !== "function") return;
    for (const key of AUTH_COOKIE_KEYS) {
        cookies.remove(key, cookieOptions);
    }
};

export const getInitialAuthState = (cookies) => {
    if (!cookies || typeof cookies.get !== 'function') return { jwtToken: null, user: {} };
    const token = cookies.get("tokenR");
    const userObj = cookies.get("userR");
    if (token && hasValidToken(token)) return { jwtToken: token, user: userObj || {} };
    return { jwtToken: null, user: {} };
};
